import React from "react";
import Button from "@mui/material/Button";

export function BigButton(props) {
  const { mode } = props;
  let style = {
    width: "377px",
    height: "74px",
    borderRadius: "8.4px",
    background: "#f9d023",
    fontSize: "24px",
    margin: "48px 0 16px",
    textTransform: "none",
    color: "#000",
  };
  if (mode === "kiosk") {
    style = {
      width: "377px",
      height: "74px",
      borderRadius: "50px",
      background: "#F9810C",
      fontSize: "24px",
      marginTop: 70,
      textTransform: "none",
      color: "#000",
    };
  }
  return <Button style={style} variant="contained" {...props} />;
}

export function ClientButton(props) {
  const { background, textcolor } = props;
  const style = {
    background: background || "#7165e3",
    width: "261px",
    height: "52px",
    borderRadius: "10px",
    boxShadow: "none",
    color: textcolor || "#000",
    textTransform: "none",
  };
  return <Button style={style} variant="contained" {...props} />;
}

export function ClientOutlinedButton(props) {
  const style = {
    width: "261px",
    height: "52px",
    borderRadius: "10px",
    border: "solid 1px #888",
    color: "#888",
    boxShadow: "none",
    textTransform: "none",
  };
  return <Button style={style} variant="outlined" {...props} />;
}

export function BigClientOutlinedButton(props) {
  const { mode } = props;
  let style = {
    width: "377px",
    height: "74px",
    borderRadius: "8.4px",
    fontSize: "24px",
    margin: "16px 0 0px",
    border: "solid 1px #888",
    color: "#888",
    textTransform: "none",
  };
  if (mode === "kiosk") {
    style = {
      width: "377px",
      height: "74px",
      borderRadius: "50px",
      fontSize: "24px",
      marginTop: 16,
      border: "solid 1px #888",
      color: "#888",
      textTransform: "none",
    };
  }
  return <Button style={style} variant="outlined" {...props} />;
}
